import { Injectable } from '@angular/core';
import moment from 'moment';
import * as _ from "lodash";
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  dateArr: string[] = []; //Array where rest of the dates will be stored
  prevDate: any;
  nextDate: any;
  filterObj :any = [];
  filterObjSingle :any = [];
  filterArr: any[] = [{ "name": "1D", "flag": true }, { "name": "1W", "flag": false }, { "name": "1M", "flag": false }, { "name": "YTD", "flag": false }];
  tickFormat = ["%H:%M", "%Y-%m-%d", '%Y-%m-%d', '%Y-%b'];
  filterJson;
  constructor() { }
  setFilterJson(obj){ this.filterObj = obj;};
  getFilterJson(){ return this.filterObj};
  clearFilterJson(){ this.filterObj = {}; }
  setEnterpriseFilter(obj){ 
    this.filterObj = obj;
  };
  getEnterpriseFilter(){ 
    return this.filterObj 
  };
  clearEnterpriseFilter(){ this.filterObj = []; }
  setPlantFilter(obj){ 
    this.filterObjSingle = obj;
  };
  getPlantFilter(){ 
    return this.filterObjSingle ;
  };
  clearPlantFilter(){ this.filterObjSingle = []; }


  getDateIntervalBasedONStartDate(startDate: string): string[] {
    this.dateArr = [];
    this.prevDate = "";
    this.prevDate = "";
    this.prevDate = moment(startDate);
    this.nextDate = moment(startDate).add(30, 'd');
    //extracting date from objects in MM-DD-YYYY format
    this.prevDate = moment(this.prevDate._d).format('MM-DD-YYYY');
    this.nextDate = moment(this.nextDate._d).format('MM-DD-YYYY');
    //creating JS date objects
    var start = new Date(this.prevDate);
    var end = new Date(this.nextDate);
    //Logic for getting rest of the dates between two dates("FromDate" to "EndDate")
    while (start < end) {
      this.dateArr.push(moment(start).format('YYYY-MM-DD'));
      var newDate = start.setDate(start.getDate() + 1);
      start = new Date(newDate);
    }
    return this.dateArr;
  }
  ///////////////////for Excel download map headers to dataId
  changeTableHeaderToLabel(headers, data) {
    let finalArray = [];
    if (headers && headers.length && data && data.length) {
      _.each(data, (d) => {
        var json1 = {};
        _.each(headers, (h) => {
          json1[h['labelValue']] = d[h['dataId']]
        })
        finalArray = finalArray.concat(json1);
      });
    }
    else {
      if (headers && headers.length) {
        var json1 = {};
        _.each(headers, (h) => {
          json1[h['labelValue']] = '';
        })
        finalArray = [json1];
      }

    }
    return finalArray
  }
  getMapJsonfromEnterprisedata(arr) {
    var mapJson = [];
    var timeZoneParam = [];
    var zoom = 2;
    var enterpriseKey;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].data) {
        for (var j = 0; j < arr[i].data.length; j++) {
          if (arr[i].data[j].data) {
            for (var k = 0; k < arr[i].data[j].data.length; k++) {
              if (arr[i].data[j].data[k].data) {
                for (var m = 0; m < arr[i].data[j].data[k].data.length; m++) {
                  let titleName = arr[i].data[j].data[k].data[m].title;
                  let displayName = arr[i].data[j].data[k].data[m].displayName;
                  let brandTitleName = arr[i].data[j].data[k].title;
                  let brandDisplayName = arr[i].data[j].data[k].branchDisplayName;
                  arr[i].data[j].data[k].displayName = brandTitleName;
                  arr[i].data[j].data[k].title = brandDisplayName;

                  arr[i].data[j].data[k].data[m].displayName = titleName
                  arr[i].data[j].data[k].data[m].title = displayName
                  if (arr[i].data[j].data[k].data[m].map != undefined) {

                    /*$rootScope.selectedBuildingList.push(arr[i].data[j].data[k].data[m].title);*/
                    mapJson.push(arr[i].data[j].data[k].data[m].map);
                    timeZoneParam.push(arr[i].data[j].data[k].data[m].timezone);
                    zoom = 2;
                    enterpriseKey = "all";
                  }
                }
              }
            }
          }
        }
      }


    }
    return { mapJson, timeZoneParam, zoom, enterpriseKey };
  }

  convertDateTime(oldDate) {

    let newDate;

    let oldDateStart = oldDate
    let hoursDiff = oldDateStart.getHours() - oldDateStart.getTimezoneOffset() / 60;
    let minutesDiff = (oldDateStart.getHours() - oldDateStart.getTimezoneOffset()) % 60;
    oldDateStart.setHours(hoursDiff);
    oldDateStart.setMinutes(minutesDiff);


    newDate = oldDateStart;
    let selDate = JSON.stringify(newDate);
    let fromDate = selDate.slice(1, 11);
    let finalDate;
    finalDate = fromDate;
    return finalDate;

  }

  convertGraphtoExcelDownloadData(data: [], xAxis?: string, yAxis?: string,highcharts?:boolean) {
    if (data && data.length > 0) {
      let finalArr = [];
      _.each(data, (outer) => {
        let x;
        let y;
        if(highcharts){
           x = outer['timeStamp'];
           y = outer['data'];
        }else{
           x = outer['x'];
           y = outer['y'];
        }
        let k = _.map(y, (inner, index) => {
          return { [xAxis]: x[index], [yAxis]: y[index], "name": outer['name'] }
        });
        finalArr = finalArr.concat(k);
      })
      return finalArr;
    }
    else {
      return [];
    }
  }

  getGraphXaxisTickFormat(qrSelection) {
    let index = -1;
    this.filterArr.forEach((json, i) => {
      if (qrSelection == json.name) {
        index = i;
      }
    });
    if (index == -1) {
      return '%Y-%m-%d %H:%M:%S';
    }
    else {
      return this.tickFormat[index];
    }
  }

  convertMinsandHourstomilliseconds(inputTime) {
    let outputinMs;
    if (inputTime.includes('MIN')) {
      let mins = +inputTime[0] + inputTime[1]
      outputinMs = mins * 60 * 1000;
      return outputinMs
    }
    else if (inputTime.includes('HOUR')) {
      let hours = (inputTime == 'HOUR') ? 1 : +inputTime[0]
      outputinMs = hours * 60 * 60 * 1000;
      return outputinMs
    }
    else {
      return -1;
    }

  }
  convertXaxisForHighcharts(interval, dateStamp) {
    let dateList = [];
    var monthNames = ["", "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    ];

    switch (interval) {
      case 'Months':
        {
          for (var monthsIndex = 0; monthsIndex < dateStamp.length; monthsIndex++) {
            dateList.push(monthNames[parseInt(dateStamp[monthsIndex].split('T')[0].split('-')[1])] + " " + dateStamp[monthsIndex].split('T')[0].split('-')[0].substring(2, 4));
          }
        }
        break;
      case 'Weeks':
        {
          for (var weeksIndex = 0; weeksIndex < dateStamp.length; weeksIndex++) {
            var fromDate = dateStamp[weeksIndex].split('T')[0].split('-')[2] + "-" + dateStamp[weeksIndex].split('T')[0].split('-')[1];
            var toDate = "";

            if (weeksIndex + 1 > dateStamp.length - 1) {
              toDate = "today";
            } 
            dateList.push(fromDate + " to " + toDate);
          }
        }
        break;
      case 'Days':
        {
          for (var daysIndex = 0; daysIndex < dateStamp.length; daysIndex++) {
            dateList.push(dateStamp[daysIndex].replace('T',' '));
          }
        }
        break;
      case 'Hours':
        {
          for (var hoursIndex = 0; hoursIndex < dateStamp.length; hoursIndex++) {
            dateList.push(dateStamp[hoursIndex].split('T')[1].split('.')[0]);
          }
        }
        break;

      case 'Minutes':
        {
          for (var minutesIndex = 0; minutesIndex < dateStamp.length; minutesIndex++) {
            dateList.push(dateStamp[minutesIndex].split('T')[1].split('.')[0]);
          }
        }
        break;
    }
    return dateList;
  }
}
